import addClass from "../utilities/add-class";
import removeClass from "../utilities/remove-class";

export default function toggleCardForm(el) {
  const cardPaymentBlock = el.querySelector(".card-payment-block");
  const radioToggleInputs = Array.prototype.slice.call(
    el.querySelectorAll(".radio-toggle__input")
  );

  radioToggleInputs.forEach(input => {
    input.addEventListener("click", toggleVisibility);
  });

  function toggleVisibility(e) {
    const input = e.target;

    if (input.value === "false" && input.checked) {
      addClass(cardPaymentBlock, "card-payment-block--hidden");
    } else {
      removeClass(cardPaymentBlock, "card-payment-block--hidden");
    }
  }
}
